/**
 * Normalize a date-like value; returns null if missing or invalid.
 * @param {string|number|Date|null|undefined} value
 * @returns {string|number|Date|null}
 */
export function normalizeDateOrNull(value) {
  if (value == null || value === "") return null;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : value;
}

/**
 * Estimated route: pickup/dropoff times aligned with admin modal / broadcast semantics.
 * @param {object} ride
 * @returns {{ pickupAt: *, dropoffAt: * }}
 */
export function getEstimatedRouteTimes(ride) {
  const userMode = !!ride?.isUserDateTime;
  const pickupAt = userMode
    ? normalizeDateOrNull(ride?.pickupDate) ?? normalizeDateOrNull(ride?.scheduledAt)
    : normalizeDateOrNull(ride?.scheduledAt);
  const dropoffAt = normalizeDateOrNull(ride?.dropoffDate);
  return { pickupAt, dropoffAt };
}

/**
 * Final route (driver actual): start/end lifecycle times.
 * @param {object} ride
 * @returns {{ pickupAt: *, dropoffAt: * }}
 */
export function getFinalRouteTimes(ride) {
  const pickupAt =
    normalizeDateOrNull(ride?.rideStartTime) ?? normalizeDateOrNull(ride?.startedAt);
  const dropoffAt =
    normalizeDateOrNull(ride?.rideEndTime) ?? normalizeDateOrNull(ride?.completedAt);
  return { pickupAt, dropoffAt };
}
